// The Branches sell-speed figures (AI sell speed, Listing Coverage mix and
// chips) were written for DaysToSellCategory ("Fast (<45d)" … "Very Slow"),
// which the API no longer sends. Units carry the sell-speed bucket as
// PredictedBucket instead: the survival lake writes "0-30d Quick" … "180+d
// Critical", the legacy classifier "Quick Sell" … "Critical".

const BUCKET_LABELS = [
    ['critical', 'Very Slow (180+d)'],
    ['slow', 'Slow (91-180d)'],
    ['normal', 'Normal (31-90d)'],
    ['quick', 'Fast (0-30d)'],
];

/** "Fast …" / "Normal …" / "Slow …" / "Very Slow …", or null without a prediction. */
export const sellSpeedCategory = (unit) => {
    if (!unit) return null;
    if (unit.DaysToSellCategory) return unit.DaysToSellCategory;
    const bucket = String(unit.PredictedBucket || '').toLowerCase();
    if (!bucket) return null;
    const hit = BUCKET_LABELS.find(([key]) => bucket.includes(key));
    return hit ? hit[1] : null;
};
